export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';



// WEBPACK FOOTER //
// ./src/api/helpers/httpMethods.js